<script lang="ts" setup>
defineProps<{
  to: string
  text: string
}>()
</script>

<template>
  <!-- <RouterLink :to="to">
    <div
      class="nav-item group flex items-center gap-2 xl:gap-4h-[30px] bg-none w-full text-secondaryBlack text-sm p-1 px-2 xl:pl-12 mb-2 hover:bg-primaryBlue hover:text-white transition-all"
    >
      <div
        class="nav-circle circle w-[8px] h-[8px] xl:w-[10px] xl:h-[10px] bg-primaryBlue shrink-0 group-hover:bg-none opacity-0 transition-opacity"
      ></div>
      <slot />
      <span class="font-light xl:flex hidden">{{ text }}</span>
    </div>
  </RouterLink> -->
  <RouterLink :to="to">
    <div
      class="nav-item group flex items-center gap-2 xl:gap-2 -my-2 py-2 bg-none w-full text-secondaryBlack text-sm pl-2 xl:pl-12 pr-4 hover:font-semibold transition-all"
    >
      <div
        class="icon p-2 bg-slate-50 rounded-full group-hover:text-white group-hover:bg-primary transition-all group-hover:scale-105"
      >
        <slot />
      </div>
      <span class="xl:flex hidden">{{ text }}</span>
    </div>
  </RouterLink>
</template>
<style scoped>
.router-link-active .icon {
  @apply bg-primaryBlue text-white;
}
.router-link-active span {
  font-weight: 600;
}
</style>
